import { gql } from '@apollo/client';
import { REPORTING_REQUIREMENT_DETAIL } from '../fragments/reportingRequirement';

export const RESET_REPORTING_REPORTER_OVERRIDE = gql`
  mutation resetReportingReporterOverride($input: ResetReportingReporterOverrideInput!) {
    result: resetReportingReporterOverride(input: $input) {
      requirement {
        ...reportingRequirementDetail
      }
      periodsCreated
      periodsUpdated
      periodsDeleted
      reporterDatesUpdated
      formUsersAdded
      reportersWithoutDates
    }
  }
  ${REPORTING_REQUIREMENT_DETAIL}
`;
